<vwui-modal-header>
  Project downloaden
</vwui-modal-header>
<vwui-modal-body>
  <p class="mb-4">
    Vink aan welke informatie je wilt tonen op de project referentie sheet.
  </p>
  @if (unfilteredData$ | async; as data) {
    <ng-container [formGroup]="form">
      <h2 class="text-base font-medium mt-4 mb-2">Getoonde eigenschappen</h2>
      <vwui-spacer-group class="max-h-48 overflow-y-scroll border border-neutral-2 rounded p-1">
        <div formGroupName="contractAttributes">
          <vwui-checkbox formControlName="selected">Contract</vwui-checkbox>
          <vwui-spacer-group spacing="xxs" class="ml-4 mt-1">
            @for (pair of (data.contractAttributes | keyvalue); track pair) {
              <vwui-checkbox
                [formControl]="getFieldControl('contractAttributes', pair.key, pair.value)">
                {{ getFieldLabel(pair.key, pair.value) || (pair.key | attributeKeyTranslate) }}
              </vwui-checkbox>
            }
          </vwui-spacer-group>
        </div>
        <div formGroupName="attributes">
          <vwui-checkbox formControlName="selected">Kenmerken</vwui-checkbox>
          <vwui-spacer-group spacing="xxs" class="ml-4 mt-1">
            @for (pair of (data.attributes | keyvalue); track pair) {
              <vwui-checkbox
                [formControl]="getFieldControl('attributes', pair.key, pair.value)">
                {{ getFieldLabel(pair.key, pair.value) || (pair.key | attributeKeyTranslate) }}
              </vwui-checkbox>
            }
          </vwui-spacer-group>
        </div>
        <vwui-checkbox formControlName="teamMembers">Projectteam VolkerWessels</vwui-checkbox>
        <vwui-checkbox formControlName="relations">Ontwerpteam</vwui-checkbox>
      </vwui-spacer-group>
      <div class="mt-4 mb-2 flex justify-between items-center">
        <h2 class="text-base font-medium m-0" [class.text-error]="form.controls.selectedPhotos.invalid">Fotoblad foto's</h2>
        <div class="rounded-xl px-4 text-xs bg-opacity-30 leading-6 font-medium"
        [ngClass]="form.controls.selectedPhotos.valid ? 'bg-success' : 'bg-error'">Selectie (max 5)</div>
      </div>
      <app-select-photos [photos]="data.photos" formControlName="selectedPhotos"></app-select-photos>
      <h2 class="text-base font-medium mt-4 mb-2">Fotoblad layout</h2>
      <app-select-photo-layout formControlName="photoLayout" [totalPhotosSelected]="form.controls.selectedPhotos.value.length"></app-select-photo-layout>
    </ng-container>
  }
</vwui-modal-body>
<vwui-modal-footer>
  <vwui-button class="is-primary" (click)="print()" icon="vwui-import" [disabled]="!form.valid || (dataLoading$|async)">
    Exporteren
  </vwui-button>
</vwui-modal-footer>
